import {Injectable} from '@angular/core';
import {LokijsService} from './database/lokijs.service';
import {ConfigurationModel} from '../models/configuration.model';
import {OperatorModel} from '../models/operator.model';
import {CollectionsNames} from '../definitions/collections-names';
import {MobileConfigurationModel} from '../models/mobile-configuration.model';
import {SimpleEngineerBeanModel} from '../models/simple-engineer-bean.model';
import {NominalModel} from '../models/nominal.model';
import {ContactModel} from '../models/contact.model';
import {CustomerModel} from '../models/customer.model';
import {DocumentModel} from '../models/document.model';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {SiteModel} from '../models/site.model';
import {PtserialBeansModel} from '../models/ptserial-beans.model';
import {PriceListDetailModel} from '../models/price-list-detail.model';
import {HaccessModel} from '../models/haccess.model';
import {SaccessModel} from '../models/saccess.model';
import {PriceListModel} from '../models/price-list.model';
import {CustomerLocationDTOModel} from '../models/customerLocationDTO.model';
import {ProjectDTOModel} from '../models/projectDTO.model';
import {ServiceJobDTOModel} from '../models/service-job-DTO.model';
import {MeterReadingDTOModel} from '../models/meter-reading-DTO.model';
import {WsTaskDTOModel} from '../models/ws-task-DTO.model';
import {HrateModel} from '../models/hrate.model';
import {PaymentTypeModel} from '../models/payment-type.model';
import {SysConfigModel} from '../models/sys-config.model';
import {ErrorLogModel} from '../models/error-log.model';
import {ActionModel} from '../models/action.model';
import {ActionTypeModel} from '../models/action-type.model';
import {ActionPriorityModel} from '../models/action-priority.model';
import {ScreenPreferencesModel} from '../models/screen-preferences.model';
import {LoadingController} from '@ionic/angular';
import { BinLocationModel } from '../models/bin-location.model';

@Injectable({
    providedIn: 'root'
})
export class StateManagerService {


    configuration = new Array<ConfigurationModel>();
    operators = new Array<OperatorModel>();
    operatorsAndAPIKey = new Array<OperatorModel>();
    mobileConfiguration = new Array<MobileConfigurationModel>();
    depots = [];
    engineers = new Array<SimpleEngineerBeanModel>();
    cashAccounts = new Array<NominalModel>();
    printers = [];
    contact = new Array<ContactModel>();
    customer = new Array<CustomerModel>();
    documentRequestType = [];
    document = new Array<DocumentModel>();
    liveDetailLines = new Array<DetaillineDTOModel>();
    liveContract = new Array<DocumentModel>();
    plantStatusList = [];
    jobStatusList = [];
    jobType = [];
    jobCertificateText = [];
    queuedDocuments = new Array<DocumentModel>();
    site = new Array<SiteModel>();
    equipment = new Array<DetaillineDTOModel>();
    equipmentDistinctPdesc = new Array<DetaillineDTOModel>();
    productType = new Array<DetaillineDTOModel>();
    sparesUsed = new Array<DetaillineDTOModel>();
    ptSerial = new Array<PtserialBeansModel>();
    priceListDetails = new Array<PriceListDetailModel>();
    haccess = new Array<HaccessModel>();
    saccess = new Array<SaccessModel>();
    policy = new Array<PriceListDetailModel>();
    priceList = new Array<PriceListModel>();
    meterType = new Array<MeterReadingDTOModel>();
    hireDept = [];
    hireDeptGroup = [];
    dept = [];
    deptGroup = [];
    customerLocation = new Array<CustomerLocationDTOModel>();
    project = new Array<ProjectDTOModel>();
    serviceJob = new Array<ServiceJobDTOModel>();
    docServiceJobTemp = new Array<ServiceJobDTOModel>();
    jobTemplate = [];
    mandatoryMeters = new Array<MeterReadingDTOModel>();
    tasks = new Array<WsTaskDTOModel>();
    hRates = new Array<HrateModel>();
    return = new Array<DocumentModel>();
    paymentMethods = new Array<PaymentTypeModel>();
    systemConfiguration = new Array<SysConfigModel>();
    errorLog = new Array<ErrorLogModel>();
    action = new Array<ActionModel>();
    queuedAction = new Array<ActionModel>();
    actionType = new Array<ActionTypeModel>();
    actionPriority = new Array<ActionPriorityModel>();
    screenPreferences = new Array<ScreenPreferencesModel>();
    stockCounts = new Array<DocumentModel>();
    scannedBarcodes = [];
    binLocations = new Array<BinLocationModel>();
    loading: any;
    productBarcodeStockTake = [];


    constructor(private loki: LokijsService,
                private collectionNames: CollectionsNames,
                private loadingController: LoadingController) {
    }

    initializeCache() {
        this.configuration = new Array<ConfigurationModel>();
        this.operators = new Array<OperatorModel>();
        this.mobileConfiguration = new Array<MobileConfigurationModel>();
        this.depots = [];
        this.engineers = new Array<SimpleEngineerBeanModel>();
        this.cashAccounts = new Array<NominalModel>();
        this.printers = [];
        this.contact = new Array<ContactModel>();
        this.customer = new Array<CustomerModel>();
        this.documentRequestType = [];
        this.document = new Array<DocumentModel>();
        this.liveDetailLines = new Array<DetaillineDTOModel>();
        this.liveContract = new Array<DocumentModel>();
        this.plantStatusList = [];
        this.jobStatusList = [];
        this.jobType = [];
        this.jobCertificateText = [];
        this.queuedDocuments = new Array<DocumentModel>();
        this.site = new Array<SiteModel>();
        this.equipment = new Array<DetaillineDTOModel>();
        this.equipmentDistinctPdesc = new Array<DetaillineDTOModel>();
        this.productType = new Array<DetaillineDTOModel>();
        this.sparesUsed = new Array<DetaillineDTOModel>();
        this.ptSerial = new Array<PtserialBeansModel>();
        this.priceListDetails = new Array<PriceListDetailModel>();
        this.haccess = new Array<HaccessModel>();
        this.saccess = new Array<SaccessModel>();
        this.policy = new Array<PriceListDetailModel>();
        this.priceList = new Array<PriceListModel>();
        this.meterType = new Array<MeterReadingDTOModel>();
        this.hireDept = [];
        this.hireDeptGroup = [];
        this.dept = [];
        this.deptGroup = [];
        this.customerLocation = new Array<CustomerLocationDTOModel>();
        this.project = new Array<ProjectDTOModel>();
        this.serviceJob = new Array<ServiceJobDTOModel>();
        this.docServiceJobTemp = new Array<ServiceJobDTOModel>();
        this.jobTemplate = [];
        this.mandatoryMeters = new Array<MeterReadingDTOModel>();
        this.tasks = new Array<WsTaskDTOModel>();
        this.hRates = new Array<HrateModel>();
        this.return = new Array<DocumentModel>();
        this.paymentMethods = new Array<PaymentTypeModel>();
        this.systemConfiguration = new Array<SysConfigModel>();
        this.errorLog = new Array<ErrorLogModel>();
        this.action = new Array<ActionModel>();
        this.queuedAction = new Array<ActionModel>();
        this.actionType = new Array<ActionTypeModel>();
        this.actionPriority = new Array<ActionPriorityModel>();
        this.screenPreferences = new Array<ScreenPreferencesModel>();
        this.binLocations = new Array<BinLocationModel>();
    }

    saveDatabase() {
        this.loki.saveDatabase();
    }

    async loadingSpinner() {
        await this.loadingController.create({
            message: 'Updating DB',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            spinner: 'bubbles'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
    }

    update(collectionName: string, entry: any) {
        this.loki.getCollection(collectionName).update(entry);
        this.getCache(collectionName, this.loki.getCollection(collectionName).chain().data());
    }

    findAndRemove(collectionName: string, key: any) {
        this.loki.getCollection(collectionName).findAndRemove({'$loki': key});
        this.getCache(collectionName, this.loki.getCollection(collectionName).chain().data());
    }

    upsert(collectionName: string, uniqueId: string, data: any) {
        this.loki.upsert(collectionName, uniqueId, data);
        this.getCache(collectionName, this.loki.getCollection(collectionName).chain().data());
    }

    async bulkUpsert(collectionName: string, uniqueId: string, dataArray: any []) {
        await this.loki.bulkUpsert(collectionName, uniqueId, dataArray);
        this.getCache(collectionName, this.loki.getCollection(collectionName).chain().data());
    }

    getCollection(collectionName: string): any {
        const coll = this.getCache(collectionName, null);
        if (!coll || coll.length === 0) {
            const data = this.loki.getCollection(collectionName).chain().data();
            return this.getCache(collectionName, data);
        }
        return coll;
    }

    clear(collectionName: string) {
        this.loki.getCollection(collectionName).clear();
        this.getCache(collectionName, []);
    }

    testCache() {
        const t0 = performance.now();
        // tslint:disable-next-line:forin
        for (const n in this.collectionNames.collectionNamesEnum) {
           // this.getCollection( this.collectionNames.BINLOCATIONS );
            
            
           this.getCollection(this.collectionNames.collectionNamesEnum[n]);
           console.log(this.collectionNames.collectionNamesEnum[n], this.getCollection(this.collectionNames.collectionNamesEnum[n]));
        }
        const t1 = performance.now();
        console.log('Generating cache', t1 - t0);
    }

    getCache(collectionName: string, data: any): any {
        switch (collectionName) {
            case this.collectionNames.OPERATOR:
                if (data) {
                    if (data.length > 0) {
                        data.sort((a, b) => (a.username > b.username) ? 1 : -1);
                    }
                    this.operators = data;
                }
                return this.operators;
            case this.collectionNames.OPERATORANDAPIKEY:
                if (data) {
                    if (data.length > 0) {
                        data.sort((a, b) => (a.username > b.username) ? 1 : -1);
                    }
                    this.operatorsAndAPIKey = data;
                }
                return this.operatorsAndAPIKey;
            case this.collectionNames.CONFIGURATION:
                if (data) {
                    this.configuration = data[0] ? data[0] : data;
                }
                return this.configuration;
            case this.collectionNames.MOBILECONFIGURATION:
                if (data) {
                    this.mobileConfiguration = data[0] ? data[0] : data;
                }
                return this.mobileConfiguration;
            case this.collectionNames.DEPOT:
                if (data) {
                    this.depots = data;
                }
                return this.depots;
            case this.collectionNames.ENGINEER:
                if (data) {
                    this.engineers = data;
                }
                return this.engineers;
            case this.collectionNames.CASHACCOUNTS:
                if (data) {
                    this.cashAccounts = data;
                }
                return this.cashAccounts;
            case this.collectionNames.PRINTLIST:
                if (data) {
                    this.printers = data;
                }
                return this.printers;
            case this.collectionNames.CONTACT:
                if (data) {
                    this.contact = data.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
                }
                return this.contact;
            case this.collectionNames.CUSTOMER:
                if (data) {
                    this.customer = data;
                }
                return this.customer;
            case this.collectionNames.DOCUMENTREQUESTTYPE:
                if (data) {
                    this.documentRequestType = data;
                }
                return this.documentRequestType;
            case this.collectionNames.DOCUMENT:
                if (data) {
                    this.document = data;
                }
                return this.document;
            case this.collectionNames.LIVEDETAILLINES:
                if (data) {
                    this.liveDetailLines = data;
                }
                return this.liveDetailLines;
            case this.collectionNames.LIVECONTRACT:
                if (data) {
                    this.liveContract = data;
                }
                return this.liveContract;
            case this.collectionNames.PLANTSTATUSLIST:
                if (data) {
                    this.plantStatusList = data;
                }
                return this.plantStatusList;
            case this.collectionNames.JOBSTATUSLIST:
                if (data) {
                    this.jobStatusList = data;
                }
                return this.jobStatusList;
            case this.collectionNames.JOBTYPE:
                if (data) {
                    this.jobType = data;
                }
                return this.jobType;
            case this.collectionNames.JOBCERTIFICATETEXT:
                if (data) {
                    this.jobCertificateText = data;
                }
                return this.jobCertificateText;
            case this.collectionNames.QUEUEDDOCUMENTS:
                if (data) {
                    this.queuedDocuments = data;
                }
                return this.queuedDocuments;
            case this.collectionNames.SITE:
                if (data) {
                    this.site = data;
                }
                return this.site;
            case this.collectionNames.EQUIPMENT:
                if (data) {
                    this.equipment = data;
                }
                return this.equipment;
            case this.collectionNames.EQUIPMENTDISTINCTPDESC:
                if (data) {
                    this.equipmentDistinctPdesc = data;
                }
                return this.equipmentDistinctPdesc;
            case this.collectionNames.PRODUCTTYPE:
                if (data) {
                    this.productType = data;
                }
                return this.productType;
            case this.collectionNames.SPARESUSEDINWS:
                if (data) {
                    this.sparesUsed = data;
                }
                return this.sparesUsed;
            case this.collectionNames.PTSERIAL:
                if (data) {
                    this.ptSerial = data;
                }
                return this.ptSerial;
            case this.collectionNames.PRICELISTDETAILS:
                if (data) {
                    this.priceListDetails = data;
                }
                return this.priceListDetails;
            case this.collectionNames.HACCESS:
                if (data) {
                    this.haccess = data;
                }
                return this.haccess;
            case this.collectionNames.SACCESS:
                if (data) {
                    this.saccess = data;
                }
                return this.saccess;
            case this.collectionNames.POLICY:
                if (data) {
                    this.policy = data;
                }
                return this.policy;
            case this.collectionNames.PRICELIST:
                if (data) {
                    this.priceList = data;
                }
                return this.priceList;
            case this.collectionNames.METERTYPE:
                if (data) {
                    this.meterType = data;
                }
                return this.meterType;
            case this.collectionNames.HIREDEPT:
                if (data) {
                    this.hireDept = data;
                }
                return this.hireDept;
            case this.collectionNames.HIREDEPTGROUP:
                if (data) {
                    this.hireDeptGroup = data;
                }
                return this.hireDeptGroup;
            case this.collectionNames.DEPT:
                if (data) {
                    this.dept = data;
                }
                return this.dept;
            case this.collectionNames.DEPTGROUP:
                if (data) {
                    this.deptGroup = data;
                }
                return this.deptGroup;
            case this.collectionNames.CUSTOMERLOCATION:
                if (data) {
                    this.customerLocation = data;
                }
                return this.customerLocation;
            case this.collectionNames.PROJECT:
                if (data) {
                    this.project = data;
                }
                return this.project;
            case this.collectionNames.SERVICEJOB:
                if (data) {
                    data.sort((a, b) => (a.jobNumber < b.jobNumber) ? 1 : -1);
                    this.serviceJob = data;
                }
                return this.serviceJob;
            case this.collectionNames.DOCSERVICEJOBTEMP:
                if (data) {
                    this.docServiceJobTemp = data;
                }
                return this.docServiceJobTemp;
            case this.collectionNames.JOBTEMPLATE:
                if (data) {
                    this.jobTemplate = data;
                }
                return this.jobTemplate;
            case this.collectionNames.HRATES:
                if (data) {
                    this.hRates = data;
                }
                return this.hRates;
            case this.collectionNames.MANDATORYMETERS:
                if (data) {
                    this.mandatoryMeters = data;
                }
                return this.mandatoryMeters;
            case this.collectionNames.TASKS:
                if (data) {
                    this.tasks = data;
                }
                return this.tasks;
            case this.collectionNames.RETURN:
                if (data) {
                    this.return = data;
                }
                return this.return;
            case this.collectionNames.PAYMENTMETHODS:
                if (data) {
                    this.paymentMethods = data;
                }
                return this.paymentMethods;
            case this.collectionNames.SYSTEMCONFIGURATION:
                if (data) {
                    this.systemConfiguration = data;
                }
                return this.systemConfiguration;
            case this.collectionNames.ERRORLOG:
                if (data) {
                    this.errorLog = data;
                }
                return this.errorLog;
            case this.collectionNames.ACTION:
                if (data) {
                    this.action = data;
                }
                return this.action;
            case this.collectionNames.QUEUEDACTION:
                if (data) {
                    this.queuedAction = data;
                }
                return this.queuedAction;
            case this.collectionNames.ACTIONTYPE:
                if (data) {
                    data = data.filter(at => {
                        return at.description && at.id <= 20;
                    });
                    this.actionType = data;
                }
                return this.actionType;
            case this.collectionNames.ACTIONPRIORITY:
                if (data) {
                    this.actionPriority = data;
                }
                return this.actionPriority;
            case this.collectionNames.SCREENPREFERENCES:
                if (data) {
                    this.screenPreferences = data[0] ? data[0] : data;
                }
                return this.screenPreferences;
            case this.collectionNames.STOCKCOUNTS:
                if (data) {
                    this.stockCounts = data;
                }
                return this.stockCounts;
            case this.collectionNames.PRODUCTBARCODESTOCKTAKE:
                if (data) {
                    this.productBarcodeStockTake = data;
                }
                return this.productBarcodeStockTake;
            case this.collectionNames.SCANNEDBARCODES:
                if (data) {
                    this.scannedBarcodes = data;
                }
                return this.scannedBarcodes;
            case this.collectionNames.BINLOCATIONS:
                if (data) {
                    this.binLocations = data;
                }
                return this.binLocations;
        }
    }
}
